import React, { Component } from "react";

import styles from "./cmsUsersCompanyPanel.module.scss";
import CmsUsers from "./CmsUsers";
import { withRoles } from "../../../shared/containers/containerRoles";
import { states } from "../../../reducers/queriesStates";
import { withUsers } from "../../../shared/containers/containerUsers";
import CmsUserCreateTool from "./CmsUserCreateTool";

class CmsUsersCompanyPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyId: props.companyId,
      newUser: {
        email: "",
        roleType: 0,
      },
      error: null,
    };
  }

  componentDidMount() {
    const { rolesDataState, onGetRoles } = this.props;

    if (rolesDataState === states.NOT_REQUESTED) {
      onGetRoles();
    }
  }

  componentDidUpdate(prevProps) {
    const { createUserDataState, errors } = this.props;

    if (createUserDataState === states.FAILURE && prevProps.createUserDataState === states.REQUEST) {
      this.setState({ error: errors });
      setTimeout(() => {
        this.setState({ error: null });
      }, 3000);
    }

    if (createUserDataState === states.READY && prevProps.createUserDataState === states.REQUEST) {
      this.setState({
        newUser: {
          email: "",
          roleType: 0,
        },
      });
    }
  }

  changeEmail(e) {
    const { newUser } = this.state;
    newUser.email = e.target.value;

    this.setState({ newUser });
  }

  changeRoleType(e) {
    const { newUser } = this.state;
    newUser.roleType = e.target.value;

    this.setState({ newUser });
  }

  createNewUser() {
    const { newUser, companyId } = this.state;
    const { onCreateUser } = this.props;

    onCreateUser({ ...newUser, companyId });
  }

  render() {
    const { companyId } = this.state;

    return (
      <div className={styles.usersCompanyContainer}>
        <CmsUserCreateTool companyId={companyId} />
        <CmsUsers companyId={companyId} />
      </div>
    );
  }
}

export default withUsers(withRoles(CmsUsersCompanyPanel));
